import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const InfoTooltip = ({ placement = 'top', children, message }) => {
  const renderTooltip = (props) => (
    <Tooltip id="tooltip-top" {...props}>
      {message}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      {children || <i className="fa fa-info-circle ms-3" />}
    </OverlayTrigger>
  );
};

export default InfoTooltip;